import * as React from "react"
import { differenceInSeconds } from "date-fns"
import { CertificateStatus, HostingCertificate } from "@modules/graphql/types"

export function useJustCreatedCertificate({
  certificate,
  certificateStatus,
  threshold,
}: {
  certificate?: HostingCertificate
  certificateStatus: CertificateStatus
  threshold: number
}) {
  const [isJustCreatedCert, setIsJustCreatedCert] = React.useState(false)

  React.useEffect(() => {
    const certificateCreatedAt =
      certificate && certificateStatus === CertificateStatus.Issued
        ? certificate.createdAt
        : undefined

    const certCreationAtToNow = certificateCreatedAt
      ? differenceInSeconds(new Date(), new Date(certificateCreatedAt))
      : undefined

    const isJustCreated = certCreationAtToNow
      ? certCreationAtToNow < threshold
      : false

    if (isJustCreated) {
      setIsJustCreatedCert(isJustCreated)

      const timeout = setTimeout(() => {
        setIsJustCreatedCert(false)
        clearTimeout(timeout)
      }, threshold * 1000)
    }
  })

  return { isJustCreatedCert }
}
